import React, { FunctionComponent } from 'react';
import { Symbol } from '@doveit/lego';
import * as styles from './ToolboxNavigationItem.style';

export interface ToolboxNavigationItemProps {
  icon: string,
  label: string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  active?: boolean,
  title?: string,
  ariaLabel?: string,
}

export const ToolboxNavigationItem: FunctionComponent<ToolboxNavigationItemProps> = ({
  icon,
  label,
  onClick,
  active,
  ariaLabel,
  title,
}) => (
  <button
    css={styles.base}
    onClick={onClick}
    $active={active}
    aria-label={ariaLabel || label}
    title={title || label}
  >
    <div css={styles.icon}>
      <Symbol
        path={icon}
        size={34}
      />
    </div>
    <div css={styles.label}>
      {label}
    </div>
  </button>
);

export default ToolboxNavigationItem;
